import { useEffect, useRef } from 'react';
import { incrementLoadingCount, decrementLoadingCount } from './loadingStore';

/**
 * Hook for announcing loading state changes in functional components.
 *
 * @see Spinner
 */
const useLoadingAnnouncer = ({
  active
}) => {
  const hasStarted = useRef(false);
  useEffect(() => {
    if (!hasStarted.current && active) {
      hasStarted.current = true;
      incrementLoadingCount();
    }
    return () => {
      if (hasStarted.current && active) {
        hasStarted.current = false;
        decrementLoadingCount();
      }
    };
  }, [active]);
};

/**
 * Component to be used with Class Component that needs to announce loading state.
 *
 * @see TextInput
 */
export const LoadingAnnouncerAsComponent = ({
  active
}) => {
  useLoadingAnnouncer({
    active
  });
  return null;
};
export default useLoadingAnnouncer;
//# sourceMappingURL=useAnnouncer.js.map